import React from "react";
import { QuizMap } from "./QuizMap";

export const Answer = ({answerStatus, answerData, onClose, coordinates, isFinalQuestion}) => {
    const icon = {
        success: 'maificon-check-round-small',
        warning: 'maificon-exclamation-round-small',
        danger: 'maificon-cross-round-small'
    }

    return (
        <div className={`${answerStatus}`}>
            <div className="d-lg-flex mt-5 mb-5">
                <div className={`alert -high mb-5 mb-lg-0 flex-grow-1 w-100 ${answerStatus == 'danger' ? 'error' : answerStatus}`}>
                    <p className="sr-only">Réponse à la question</p><i class={`maificon ${icon[answerStatus]}`} aria-hidden="true"></i>
                    <div className="wrapper-content">
                        <h3 className="title d-block"><strong>{answerData.title}</strong></h3>
                        <div className="content d-flex justify-content-between flex-wrap mt-3">
                            {answerData.content && answerData.content.map(c => 
                                <div className={`col-12`} dangerouslySetInnerHTML={{ __html: c }}></div>
                                )}
                        </div>
                    </div>
                </div>
                {answerData.img && 
                    <div className="pl-lg-5 flex-grow-1 w-100">
                        <img src={answerData.img.src} alt={answerData.img.title} className="w-100"/>
                    </div>
                }
                {answerData.map && coordinates.address.lat ?
                    <QuizMap coordinates={coordinates} itemData={answerData.map}/>
                    :
                    answerData.alternative ?
                    <div className="pl-lg-5 flex-grow-1 w-100">
                        {answerData.alternative.alternativeContent && <p>{answerData.alternative.alternativeContent}</p>}
                        <img src={answerData.alternative.src} alt={answerData.alternative.title} className="w-100"/>
                    </div>
                    : ''
                }
            </div>
            <div className="step-action  -horizontal-sm -vertical">
                <button className="button -primary" onClick={onClose}>{isFinalQuestion ? 'Voir le résultat' : 'Question suivante'}</button>
            </div>
        </div>
    )
}